import { render, staticRenderFns } from "./ProfileUsername.vue?vue&type=template&id=86b04e6a&scoped=true"
import script from "./ProfileUsername.vue?vue&type=script&lang=js"
export * from "./ProfileUsername.vue?vue&type=script&lang=js"
import style0 from "./ProfileUsername.vue?vue&type=style&index=0&id=86b04e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b04e6a",
  null
  
)

export default component.exports